'use strict';
import DispoHelpers from './dispoHelpers';
import { newModalFromSelector } from '../components/modal';
var giftingHelper = require('./gifting');
var summaryHelpers = require('./summary');

/**
 * @param {string} url
 * @param {Object} form
 * @param {boolean} updateModal - "false" if gift wrap is removed with CTA outside modal
 */
const addGiftWrapAjax = (url, form, updateModal = true) => {
    $.spinner().start();
    var defer = $.Deferred();
    var isRemoval = form.pids === '';
    if (url) {
        $.ajax({
            url: url,
            method: 'POST',
            data: form,
            success: (data) => {
                $.spinner().stop();
                giftingHelper.updateGiftingInformation(defer, data);
                summaryHelpers.updateTotals(data.order.totals);

                if (updateModal) {
                    data.listName = 'gift_wrap';
                    $('body').trigger('product:pushCartGiftWrapInteraction', data);
                }

                if (data.isGiftCardRemoved) {
                    giftingHelper.resetGiftCardForm();
                } else {
                    $('.success-message.giftkit').show();
                }

                $('body').trigger('wrap-updated', {
                    updateModal: updateModal
                });
                if ($('span.not-wrappable').not('.hidden').length > 0) {
                    var productId = $('span.not-wrappable').not('.hidden').parent().find('input.wrap-item:checked').eq(0).data('productUuid');
                    $('a.open-gift-wrap').attr('data-uuid', productId);
                }
                if (DispoHelpers.isDispoActive() && isRemoval) {
                    var isNoSpliced = $('.noSpliced').length > 0;
                    $('.chosen-gift-box').attr('data-addedwrapitems', '');
                    $('.chosen-gift-box').parents('.copy-wrapper-gift-container').attr('data-addedwrapitems', '');
                    if (isNoSpliced) {
                        $('.copy-wrapper-gift-container').attr('data-addedwrapitems', '');
                    }
                    $('.cc-giftOptionsModal .js-gift-options-modal-close').trigger('click');
                    DispoHelpers.giftOptionsLabel();
                }
            },
            error: (_err) => {
                $.spinner().stop();
            }
        });
    }
};
/**
 * @param {string} url
 * @param {Object} form
 */
const addGiftKitAjax = (url, form) => {
    if (!url) {
        return;
    }

    var defer = $.Deferred();
    $.ajax({
        url: url,
        method: 'POST',
        data: form,
        success: (data) => {
            $.spinner().stop();

            $('body').trigger('product:pushGiftKitInteraction', data);

            giftingHelper.updateGiftingInformation(defer, data);
            summaryHelpers.updateTotals(data.order.totals);
            $('body').trigger('gift-kit-updated', form);

            if (data.minicart) {
                $('.js-close-button').show();
                $('.js-giftkit-popover').addClass('show');
                $('.js-giftkit-popover').html(data.minicart);
                if (!Foundation.MediaQuery.is('medium')) {
                    $('.minicart-veil').removeClass('hide');
                }
                setTimeout(() => {
                    if (!Foundation.MediaQuery.is('medium')) {
                        $('.minicart-veil').addClass('hide');
                    }
                    $('.js-giftkit-popover').removeClass('show');
                }, 3000);
                window.scrollTo(0, 0);
            }

            if (data.isGiftCardRemoved) {
                giftingHelper.resetGiftCardForm();
            }
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

/** Class representing gift wapping options at checkout */
class Gift {
    /** Gift Options accordion behavior */
    run () {
        const $giftOptions = $('.gifting-card .gift__container');

        if ($giftOptions.length) {
            this.wrap();
            this.kit();
            this.wrapEventListeners();
            this.kitEventListeners();
        }
    }

    /** Gift Wrap addition and removal */
    wrap () {
        const $giftWrap = $('.gifting-card .gift__wrap');
        this.giftWrapItemsLimit = parseInt($giftWrap.data('wrap-items-limit'));

        $('.open-gift-wrap').off('click').on('click', (e) => {
            e.preventDefault();

            $('.section-selected').removeClass('section-selected');
            $(e.currentTarget).parents('.copy-wrapper-gift-container').addClass('section-selected');

            const modal = newModalFromSelector('gift-wrap-content');
            const modalContent = $(modal.modalBox);

            this.updateWrapCtas(modalContent, false, e);
            $(modal.modalBox).addClass('gift-wrap-modal');
            $('.js-gift-options-modal-close').trigger('click');
            modal.open();
            modalContent.on('click', '.cc-giftWrap-backIcon', (currentTarget) => {
                $('.js-gift-wrap-modal-close').trigger('click');
                var modal = $(currentTarget).closest('#gift-wrap-content');
                var giftOptionsModalButton = $(document).find('.js-openGiftOptionsModal').not(modal.find('.js-openGiftOptionsModal'));
                giftOptionsModalButton.first().trigger('click');
            });
            modalContent.on('click', '.modal-close', () => {
                modal.close();
                modal.destroy();
            });

            this.showProducts();
            this.wrapModalListeners(modal);
        });
    }

    wrapEventListeners () {
        // Remove gift wrap from outside modal
        $('body').off('click', '.remove-gift-wrap').on('click', '.remove-gift-wrap', (e) => {
            const url = $(e.currentTarget).data('url');
            const form = {
                giftMessage: '',
                pids: ''
            };
            addGiftWrapAjax(url, form, false);
        });
    }

    wrapModalListeners (modal) {
        const modalContent = $(modal.modalBox);

        modalContent.find('input.wrap-item').on('change', (e) => {
            this.updateWrapCtas(modalContent, $(e.currentTarget),false);
        });

        // Add gift wrap
        modalContent.on('click', '.add-gift-message', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let pids = modalContent.find('input.wrap-item:checked').toArray()
                .map((e) => {
                    return $(e).data('productUuid');
                })
                .join(',');

            let skus = modalContent.find('input.wrap-item:checked').toArray()
                .map((e) => {
                    return $(e).data('analytics-pid');
                })
                .join('-');
            localStorage.setItem('giftwrappedProducts', skus);
            let productsname = modalContent.find('input.wrap-item:checked').toArray()
                .map((e) => {
                    return $(e).data('analytics-name');
                })
                .join('-');
            $('body').trigger('gift-wrap-product-saved', {productsname: productsname, skus: skus});
            const updateCartUrl = $(e.target).data('url');
            const form = {
                giftMessage: modalContent.find('.js-gift-message').val(),
                pids: pids
            };

            addGiftWrapAjax(updateCartUrl, form);
        });

        $('body').off('wrap-updated');
        $('body').on('wrap-updated', (evt, data) => {
            if (data.updateModal) {
                // Copy configuration from created modal to hidden container
                modalContent.find('input.wrap-item').toArray().forEach((e) => {
                    $('#gift-wrap-content').find(`input#${e.id}`)
                        .prop('checked', $(e).prop('checked'))
                        .attr('checked', $(e).prop('checked'));
                });
                const message = modalContent.find('.js-gift-message').val();
                $('#gift-wrap-content').find('.js-gift-message').val(message).text(message);
                modal.close();
            } else {
                // Manually reset values of hidden container since no modal is used
                $('#gift-wrap-content').find(`input.wrap-item`)
                    .prop('checked', false)
                    .attr('checked', false);
                $('#gift-wrap-content').find('.js-gift-message').val('').text('');
            }
        });
    }

    updateWrapCtas (modalContent, $selectedOption, updateModal) {
        const wrappedItemsNumber = modalContent.find('input.wrap-item:checked').length;

        // Toggle CTA
        modalContent.find('.add-gift-message').prop('disabled', wrappedItemsNumber === 0);

        // Reset product cards states (only for wrappable items)
        modalContent.find('.product-line-item').removeClass('product-line-item-disabled');
        modalContent.find('.product-line-item:not(.product-line-item-unwrappable) input.wrap-item').prop('disabled', false);
        modalContent.find('.not-wrappable').addClass('hidden');

        // Check if limit is reached
        if (wrappedItemsNumber >= this.giftWrapItemsLimit) {
            modalContent.find('input.wrap-item:not(:checked)')
                .prop('disabled', true)
                .closest('.product-line-item').addClass('product-line-item-disabled');

            if ($selectedOption) {
                $selectedOption.closest('.product-line-item').next('.not-wrappable').removeClass('hidden');
            }

            if (updateModal) {
                let datauuidr = $(updateModal.currentTarget).attr('data-uuid');
                $('#wrap-' + datauuidr).closest('.product-line-item').parent().find('.not-wrappable').removeClass('hidden');
            }
        }

        if ($('#isDispoCountry').val() !== 'false') {
            this.manageDispoWrap();
        }
    }

    manageDispoWrap () {
        $('.copy-wrapper-gift-container').each(function () {
            var addedWrapItems = $(this).attr('data-addedwrapitems');
            if (addedWrapItems) {
                var uuidArray = addedWrapItems.split(',');
                uuidArray.forEach(function (uuid) {
                    var addedItemUUID = uuid.trim();
                    $('input.wrap-item[data-product-uuid="' + addedItemUUID + '"]').prop('checked', true);
                });
            }
        });
    }

    showProducts () {
        var elementsOfSlice = $('.chosen-gift-box').parents('.checkout-product-summary').find('.productCheckout');
        elementsOfSlice.each(function () {
            elementsOfSlice.toArray().forEach(function (elem) {
                $('.gift-wrap-content-container .js-product-giftwrap-container-' + elem.dataset.productLineItem).removeClass('hidden');
            });
        });
    }

    /** DIY Gift Kit addition and removal */
    kit () {
        const $giftKit = $('.gifting-card .gift__kit');

        if (!$giftKit.length) {
            return;
        }

        $('.open-gift-kit').off('click').on('click', (e) => {
            e.preventDefault();
            const modal = newModalFromSelector('gift_kit_content');
            const modalContent = $(modal.modalBox);
            modalContent.addClass('gift-kit-modal');
            $('.js-gift-options-modal-close').trigger('click');
            modal.open();
            modalContent.on('click', '.cc-giftKit-backIcon', (currentTarget) => {
                $('.js-gift-kit-modal-close').trigger('click');
                var modal = $(currentTarget).closest('#gift-kit-content');
                var giftOptionsModalButton = $(document).find('.js-openGiftOptionsModal').not(modal.find('.js-openGiftOptionsModal'));
                giftOptionsModalButton.first().trigger('click');
            });
            modalContent.on('click', '.modal-close', () => {
                modal.close();
                modal.destroy();
            });

            // Gift Kit quantity
            const $giftKitQuantity = modalContent.find('.gift__kitquantity');
            var isLongDistanceSlice = $('.chosen-gift-box').parents('.checkout-product-summary-dispo').hasClass('externalDispoShipments');
            // $('.js-additional-gift-message').toggleClass('hidden', !isLongDistanceSlice);
            $('body').off('gift-kit-updated');
            $('body').on('gift-kit-updated', (e, data) => {
                $('.gift-kit-quantity').toggleClass('hide', data.quantity === 0).text('(' + data.quantity + ')');
                $('#gift_kit_content').find('.gift__kitquantity .js-quantity-value').text(data.quantity);
                $('.chosen-gift-box').attr('data-numaddedkititems', data.quantity);
                modal.close();
                modal.destroy();
            });

            if ($giftKitQuantity.length) {
                const $value = $giftKitQuantity.find('.js-quantity-value');
                const quantityLimit = parseInt($giftKitQuantity.data('quantity-limit')) || 15;

                let quantity = parseInt($value.text(), 10);

                // Avoid multiple event listeners in case of duplicate elements
                $giftKitQuantity.first().on('gift:updateKitQuantity', (e, action) => {
                    $('.gift__kitquantity [data-action="decrease"]').prop('disabled', false);
                    $('.gift__kitquantity [data-action="increase"]').prop('disabled', false);
                    $('.js-giftkit-error-message').removeClass('show');
                    switch (action) {
                    case 'increase':
                        if (quantity < quantityLimit) {
                            quantity++;
                        }
                        break;
                    case 'decrease':
                        if (quantity > 0) {
                            quantity--;
                        }
                        break;
                    default:
                        if (quantity < quantityLimit) {
                            quantity++;
                        }
                        break;
                    }
                    $value.text(quantity);

                    if (quantity >= quantityLimit) {
                        $('.gift__kitquantity [data-action="increase"]').prop('disabled', true);
                        $('.js-giftkit-error-message').addClass('show');
                    } else if (quantity <= 0) {
                        $('.gift__kitquantity [data-action="decrease"]').prop('disabled', true);
                    }
                });

                $giftKitQuantity.on('click', 'button[data-action]', function (e) {
                    $giftKitQuantity.trigger('gift:updateKitQuantity', $(this).data('action'));
                    e.preventDefault();
                    e.stopPropagation();
                });

                $giftKitQuantity.on('click', '.add-gift-kits-to-cart', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var sumTotal = 0;
                    if ($('#isDispoCountry').val() !== 'false') {
                        $('.copy-wrapper-gift-container').each(function () {
                            var numAdded = parseInt($(this).attr('data-numaddedkititems'));
                            sumTotal += numAdded;
                        });
                        quantity = quantity + sumTotal;
                    }

                    const updateCartUrl = $(this).data('url');
                    const form = {
                        pid: $(this).data('pid'),
                        quantity
                    };
                    $('body').trigger('gift-kit-added', {quantity});
                    addGiftKitAjax(updateCartUrl, form);
                });
            }
        });
    }

    kitEventListeners () {
        // Remove gift wrap from outside modal
        $('body').on('click', '.remove-gift-kit', (e) => {
            const url = $(e.currentTarget).data('url');
            const form = {
                pid: $(this).data('pid'),
                quantity: 0
            };
            addGiftKitAjax(url, form);
        });
    }
}

const gift = new Gift();
export default gift;
